import React from "react";

/**
 * Page Layout Helpers
 * -------------------
 * This file contains reusable layout and structure components designed to
 * standardize page building across the platform. They also help with readability
 * and maintainability of the code.
 *
 * Components:
 * - PageWrapper:  A flexible vertical layout wrapper for a full page section.
 * - PageTitle:    A consistent container for section or page titles.
 * - Divider:      A vertical spacer with a horizontal line to visually separate sections.
 */

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
}
export const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  className = "",
}) => {
  return <div className={`flex flex-col gap-5 ${className}`}>{children}</div>;
};


interface PageTitleProps {
  children: React.ReactNode;
  className?: string;
}
export const PageTitle: React.FC<PageTitleProps> = ({
  children,
  className = "",
}) => {
  return <div className={`page-title ${className}`}>{children}</div>;
};


interface DividerProps {
  margin?: number;
  className?: string;
}
export const Divider: React.FC<DividerProps> = ({
  margin = 0,
  className = "",
}) => {
  return (
    <div style={{ margin: `${margin}px 0` }} className={className}>
      <hr />
    </div>
  );
};
